// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"ModalBody-modalBody-2AJ0W","modalScroller":"ModalBody-modalScroller-jDIdW","innerModalBody":"ModalBody-innerModalBody-1n-T_"};